import './whereToBuy.less'
import jd from '../../image/jd.png'
import tm from '../../image/TM.png'
import dibai from '../../image/dibai.avif'
import decathlon from '../../image/decathlon.jpg'
import kettler from '../../image/kettler.png'
import sogo from '../../image/sogo.png'
import club from '../../image/club.png'
import welcare from '../../image/welcare.png'
import backerMany from '../../image/backerMany.png'
import pchome from '../../image/pchome.jpg'
import jpsc from '../../image/jpsc.jpg'
import jp from '../../image/jp.svg'
import bhfitness from '../../image/bhfitness.jpg'
import shopee from '../../image/shopee.jpg'
import hastTings from '../../image/hastTings.jpg'
import amazon from '../../image/amazon.jpg'
import icon360ongsafitnessloei from '../../image/360ongsafitnessloei.png'
import fit2firm from '../../image/fit2firm.png'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'
import { selectLocale } from 'store/localeSlice'
export const WhereToBuy = () => {
    const intl = useIntl();
    const locale= useSelector(selectLocale);
    const chinaBuyLinkList = [
        {
            img: jd,
            url: 'https://mall.jd.com/index-16102550.html?from=pc',
            name: 'JD'
        },
        {
            img: tm,
            url: 'https://shop225493825.taobao.com/shop/view_shop.htm?spm=a21n57.1.2.1.34ad523cziieUk&appUid=RAzN8HWN8X2g1ptTidSVo99rQAdpyBEx2FFBnFx6HsBBZGnvojD',
            name: 'TM'
        }
    ]
    const buyLinkList = [
        
        // {
        //     img:decathlon,
        //     url: 'https://www.decathlon.com.hk/en/browse/b/snailcle/_/N-s7sj00',
        //     name: 'Hong Kong'
        // },
        {
            img:kettler,
            url: 'https://mtsports.hk/product-detail.shtml?product_id=686&path=92',
            name: 'Hong Kong'
        },{
            img: sogo,
            url: 'https://www.sogo.com.hk/tc/product/90609691-34/snailcle-ai-smart-bike-(snailcle-s1)',
            name: 'Hong Kong'
        },
        {
            img: club,
            url: 'https://shop.theclub.com.hk/snailcle-ai-smart-bike-white-snailcle-s1.html?___store=zh_Hant_HK',
            name: 'Hong Kong'
        },
        {
            img: pchome,
            url: 'https://24h.pchome.com.tw/prod/DEBYDB-A900G99ZW',
            name: 'Tai Wan'
        },{
            img: jpsc,
            url: 'https://shopee.tw/%E3%80%90BH%E3%80%91H680-S1-Ai%E6%99%BA%E8%83%BD%E8%9D%B8%E7%89%9B%E5%81%A5%E8%BA%AB%E8%BB%8A-i.17133621.15897285933',
            name: 'Tai Wan'
        },
        {
            img: bhfitness,
            url: 'https://www.i-bh.com.tw/Product_detail/Crosstrainer_H680',
            name: 'Tai Wan'
        },
        // {
        //     img: amazon,
        //     url: 'https://www.amazon.co.jp/-/en/Snailcle-FBU-S1-Automatic-Adjustment-Electromagnetic/dp/B0C5H8S385',
        //     name: 'Amazon, Japan',
        //     sub: '.co.jp'
        // },
        {
            img: jp,
            url: 'https://item.rakuten.co.jp/amical/z00658/',
            name: 'Japan'
        },
        {
            img:dibai,
            url: 'https://marshalfitness.com/ar-qa/products/snailcle-smart-ai-bike-the-most-advanced-indoor-cycling-bike',
            name: 'Dibai'
        },
        // {
        //     img: amazon,
        //     url: 'https://www.amazon.in/Handlebar-Adjustable-Resistance-Immersive-Real-Terrain/dp/B0C7WBTB',
        //     name: 'India',
        //     sub: '.in'
        // },
        // {
        //     img: welcare,
        //     url: 'https://welcarefitness.com/home-fitness/cardios/ai-bike',
        //     name: 'India'
        // },
        {
            img: backerMany,
            url: 'https://backermany.com/snailcle-smart-bike-bring-home-outdoor-cycling-experiences/',
            name: 'BackerMany'
        },
        {
            img: icon360ongsafitnessloei,
            url: 'http://www.360ongsafitnessloei.com/shop/stationary-bike/page/3',
            name: 'Thailand'
        },
        {
            img: fit2firm,
            url: 'http://www.fit2firm.com/shop/spin-bike/45466761/snailcle-exercise-bike.html',
            name: 'Thailand'
        },{
            img: hastTings,
            url: 'https://hasttings.ru/',
            name: 'HastTings'
        },{
            img: shopee,
            url: 'https://s.shopee.co.id/6AS9AtWM9J',
            name: 'Shopee'
        },
    ]
    return <div className='where-to-buy-pages-wrapper'>
        {/* <h1 className='title'>Where To Buy</h1> */}
        <div className='pages-container'>
            <div className='title-wrapper'>
                <div className='line'></div>
                <div className='buy-title'>{intl.formatMessage({id: 'wheretobuy.title1'})}</div>
                <div className='line'></div>
            </div>
            <div className='title' style={{marginBottom: 20}}>{intl.formatMessage({id: 'wheretobuy.con'})}</div>
            {locale === 'zh' ? <div className='buy-wrapper'>
                {
                    chinaBuyLinkList.map((item,index) => {
                        return <div className='buy-item'>
                        <a href={item.url} target='_blank' rel="noreferrer">
                            <img className='buy-link-img' src={item.img} alt="" />
                        </a>
                    </div>
                    })
                }
                
            </div> : null}
            {locale === 'zh' ? <div className='title-wrapper' style={{marginBottom: 20}}>
                <div className='line'></div>
                <div className='buy-title'>{intl.formatMessage({id: 'wheretobuy.title2'})}</div>
                <div className='line'></div>
            </div> : null}
            <div className='buy-wrapper'>
                {
                    buyLinkList.map((item, index) => {
                        return <div className='buy-item' key={index}>
                            <a href={item.url} target='_blank' rel="noreferrer">
                                <div>
                                    <img className='buy-link-img' src={item.img} alt="" />
                                    {/* {item.sub ? <span>{item.sub}</span> : null} */}
                                </div>
                            </a>
                        </div>
                    })
                }
            </div>
        </div>
    </div>
}